import Input from "../../Input";
import { INPUT_TYPES } from "../../Input";
import Button from "../../Button";
import { ECOLOR, EVARIANTS } from "../../Button/interface";
import useApi from "../../../hooks/useApi";
import { API_ROUTES } from "../../../api";
import { useState,useEffect } from "react";
import { isPositiveNumber } from "../../../utils";
import useCommonStore from "../../../store/store";
import { ToastContainer, toast } from "react-toastify";
import { getUTCDate } from "../../../utils/dateFormatter";
import "react-toastify/dist/ReactToastify.css";



const ManageRate = ({toggleManageRate,roomData:room,setgetRoomList,selectedDate}:any) => {
  const {homestayData} = useCommonStore();
  const [roomData, setRoomData] = useState({
    // roomType: room?.packageType ? room?.packageType : room?.roomType,
    ...(room?.packageType
    ? { packageType: room.packageType }
    : { roomType: room?.roomType }),
    adults: room?.adults,
    price: room?.packageType ? room?.price : room?.roomPrice,
    breakfast: room?.meals?.breakfast,
    lunch: room?.meals?.lunch,
    dinner: room?.meals?.dinner,
    allMeals: room?.meals?.allMeals,
    extraBedCharge:room?.extraBedCharge,
    maxAdults : room?.maxAdults

  });
  const [isUpdateMeal,setUpdateMeal] = useState(false);
  const [updateDefaultPrice,toggleUpdateDefaultPrice] = useState(false);


  const [error, setError] = useState({
    adults: "",
    price: "",
    breakfast: "",
    lunch: "",
    dinner: "",
    allMeals: "",
    extraBedCharge:"",
    maxAdults:"",
    child:""
  });
  //   const [childData, setChildData] = useState(
  //   room?.child?.length > 0 
  //     ? [...room.child] 
  //     : [{ maxAge: '', minAge: '', price: '' }]
  // );

  const [childData, setChildData] = useState(
  Array.isArray(room?.child) && room.child.length > 0
    ? [...room.child]
    : []
);

  const { data: updateResponse, error:updatePriceError, apiClient: updateRoomPriceClient } = useApi();


  const updateRoomPrice = async () => {
    if (isValidateInput(roomData)) {
      const url = room?.packageType ?  (API_ROUTES.DAY_OUTING_PRICE_UPDATE + "/" + room?.packageType) : (API_ROUTES.PRICE_UPDATE + "/" + room?.roomType);
      const options = {
        method: "POST",
        data: {
          isWebApp : true,
          date: getUTCDate(selectedDate),
          meals: {
            breakfast: Number(roomData?.breakfast) || 0,
            lunch: Number(roomData?.lunch) || 0,
            dinner: Number(roomData?.dinner) || 0,
            allMeals: Number(roomData?.allMeals) || 0,
          },
          adults: Number(roomData?.adults),
          room: Number(roomData?.price),
          maxAdults: Number(roomData?.maxAdults),
          homeStayId: homestayData?._id,
          extraBedCharge : Number(roomData?.extraBedCharge),
          child:childData.filter(
            obj => Object.values(obj).every(value => value !== "")
          ),
          isUpdateMeal:isUpdateMeal,
          updateDefaultPrice : updateDefaultPrice

        },
      };
      await updateRoomPriceClient(url, options);
    }
  };

  useEffect(() => {
    if (updateResponse?.status) {
      toggleManageRate(false);
      setgetRoomList(true)
      // setPriceUpdated(true);
    }
  }, [updateResponse]);

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setRoomData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

    const handleCancel = ()=>{
        toggleManageRate(false);
    }

    const isValidateInput = (value: any) => {
      setError({
        adults: "",
        price: "",
        breakfast: "",
        lunch: "",
        dinner: "",
        allMeals: "",
        extraBedCharge:"",
        maxAdults:"",
        child:""
      });
      let isValid = true;

      if(value?.price<=0){
        setError((prev) => ({ ...prev, price: "Enter valid price Value" }));
          isValid=false;    
      }
      if (!isPositiveNumber(value?.adults)) {
        setError((prev) => ({ ...prev, adults: "Enter valid adult Value" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.price)) {
        setError((prev) => ({ ...prev, price: "Enter valid price Value" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.lunch) && room?.roomType) {
        setError((prev) => ({ ...prev, lunch: "Enter valid lunch rate" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.dinner) && room?.roomType) {
        setError((prev) => ({ ...prev, dinner: "Enter valid dinner rate" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.breakfast) && room?.roomType) {
        setError((prev) => ({ ...prev, breakfast: "Enter valid breakfast rate" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.allMeals) && room?.roomType) {
        setError((prev) => ({ ...prev, allMeals: "Enter valid all meals rate" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.extraBedCharge)) {
        setError((prev) => ({ ...prev, extraBedCharge: "Enter valid all extra bed charge" }));
        isValid = false;
      }
      if (!isPositiveNumber(value?.maxAdults)) {
        setError((prev) => ({ ...prev, maxAdults: "Enter valid all maximum capacity" }));
        isValid = false;
      }
      if(value?.maxAdults<=0){
        setError((prev) => ({ ...prev, maxAdults: "Enter valid max capacity" }));
        isValid = false;
      }
      if(value?.maxAdults<value?.adults){
        setError((prev) => ({ ...prev, maxAdults: "Max Capacity can not be less than adults" }));
        isValid = false;
      }
      if(value?.adults<=0){
        setError((prev) => ({ ...prev, adults: "Enter valid adult value" }));
        isValid = false;
      }
      if(room?.child?.length && childData?.length===0){
        setError((prev) => ({ ...prev, child: "Child price is required." }));
        isValid = false;
      }
      return isValid;
    };

      useEffect(()=>{
      if(error.child){
        toast.error(error.child, {
          autoClose: 3000,
         
        });
      }
    },[error])

     const handleChange = (index, field, value) => {
      const updatedData = [...childData];
      updatedData[index][field] = Number(value);
      setChildData(updatedData);
    };  

    const addNewField = () => {
      setChildData([...childData, { minAge: '', maxAge: '', price: '' }]);
    };  

    const deleteField = (index) => {
      const updatedData = childData.filter((_, i) => i !== index);
      setChildData(updatedData);
    };

     const handleCheckboxChange = (e:any) => {
      setUpdateMeal(e.target.checked);
    };

  return (
  //      <>
  //   <div className="flex h-full flex-col md:hidden gap-y-6 mb-[50px] md:mb-0 overflow-y-auto px-3 mt-2 ">
  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Number of Adults
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Number of adults"
  //         name="adults"
  //         value={roomData?.adults}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.adults &&  <p className="text-red-600 text-sm font-bold">{error?.adults}</p>}
  //     </div>

  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Price
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Price"
  //         name="price"
  //         value={roomData?.price}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.price &&  <p className="text-red-600 text-sm font-bold">{error?.price}</p>}
  //     </div>

  //     <p className="font-['Montserrat'] font-semibold text-[16px] leading-[22px] tracking-[0.2px] text-[#000000] ">
  //       Meals Price (per person)
  //     </p>

  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Breakfast Rate (optional)
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Breakfast rate"
  //         name="breakfast"
  //         value={roomData?.breakfast}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.breakfast &&  <p className="text-red-600 text-sm font-bold">{error?.breakfast}</p>}
  //     </div>

  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Lunch rate (optional)
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Lunch rate"
  //         name="lunch"
  //         value={roomData?.lunch}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.lunch &&  <p className="text-red-600 text-sm font-bold">{error?.lunch}</p>}
  //     </div>

  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Dinner Rate (optional){" "}
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Dinner rate"
  //         name="dinner"
  //         value={roomData?.dinner}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.dinner &&  <p className="text-red-600 text-sm font-bold">{error?.dinner}</p>}
  //     </div>

  //     <div className="flex flex-col gap-y-2">
  //       <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //         Combined Meal Rate (optional)
  //       </label>
  //       <Input
  //         type={INPUT_TYPES.TEXT}
  //         placeholder="Combined meal rate"
  //         name="allMeals"
  //         value={roomData?.allMeals}
  //         onChange={onInputChange}
  //         className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //       />
  //       {error?.allMeals &&  <p className="text-red-600 text-sm font-bold">{error?.allMeals}</p>}
  //     </div>

  //     <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Extra Bed Charge
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Extra Bed Charge"
  //           name="extraBedCharge"
  //           value={roomData?.extraBedCharge}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.extraBedCharge &&  <p className="text-red-600 text-sm font-bold">{error?.extraBedCharge}</p>}
  //       </div>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Maximum Adult Capacity          
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Maximum capacity"
  //           name="maxAdults"
  //           value={roomData?.maxAdults}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.maxAdults &&  <p className="text-red-600 text-sm font-bold">{error?.maxAdults}</p>}
  //       </div>

  //     <div className="flex mt-3 flex-row gap-x-2 justify-between">
  //       <Button
  //         variant={EVARIANTS.PILL}
  //         color={ECOLOR.THREE}
  //         className="!rounded-[12px] flex-1 !px-[10px] "
  //         onClick={handleCancel}
  //       >
  //         <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#787878]">
  //           Cancel
  //         </p>
  //       </Button>
  //       <Button
  //         variant={EVARIANTS.PILL}
  //         color={ECOLOR.TWO}
  //         className="!rounded-[12px] flex-1"
  //         onClick={updateRoomPrice}
  //       >
  //         <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#FFFFFF]">
  //           Save Changes
  //         </p>
  //       </Button>
  //     </div>
  //   </div>

  //   <div className="hidden h-full md:flex justify-center gap-x-[100px] items-start px-[100px] py-[50px]">
  //     <div className="flex flex-col gap-y-6">
  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Number of Adults99
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Number of adults"
  //           name="adults"
  //           value={roomData?.adults}  
  //           onChange={onInputChange}          
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.adults &&  <p className="text-red-600 text-sm font-bold">{error?.adults}</p>}

  //       </div>

  //       <p className="font-['Montserrat'] font-semibold text-[16px] leading-[22px] tracking-[0.2px] text-[#000000] ">
  //         Meals Price (per person)
  //       </p>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Breakfast Rate (optional)
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Breakfast rate"
  //           name="breakfast"
  //           value={roomData?.breakfast}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.breakfast &&  <p className="text-red-600 text-sm font-bold">{error?.breakfast}</p>}
  //       </div>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Lunch rate (optional)
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Lunch rate"
  //           name="lunch"
  //           value={roomData?.lunch}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.lunch &&  <p className="text-red-600 text-sm font-bold">{error?.lunch}</p>}

  //       </div>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Maximum  Capacity          
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Maximum capacity"
  //           name="maxAdults"
  //           value={roomData?.maxAdults}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.maxAdults &&  <p className="text-red-600 text-sm font-bold">{error?.maxAdults}</p>}
  //       </div>
  //     </div>

  //     <div className="flex flex-col gap-y-6">
  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Price
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Price"
  //           name="price"
  //           value={roomData?.price}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.price &&  <p className="text-red-600 text-sm font-bold">{error?.price}</p>}
  //       </div>
        
  //       <div className="flex flex-col mt-[48px] gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Dinner Rate (optional){" "}
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Dinner rate"
  //           name="dinner"
  //           value={roomData?.dinner}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.dinner &&  <p className="text-red-600 text-sm font-bold">{error?.dinner}</p>}
  //       </div>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Combined Meal Rate (optional)
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Combined meal rate"
  //           name="allMeals"
  //           value={roomData?.allMeals}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.allMeals &&  <p className="text-red-600 text-sm font-bold">{error?.allMeals}</p>}
  //       </div>

  //       <div className="flex flex-col gap-y-2">
  //         <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
  //           Extra Bed Charge
  //         </label>
  //         <Input
  //           type={INPUT_TYPES.TEXT}
  //           placeholder="Extra Bed Charge"
  //           name="extraBedCharge"
  //           value={roomData?.extraBedCharge}
  //           onChange={onInputChange}
  //           className="h-[53px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
  //         />
  //         {error?.extraBedCharge &&  <p className="text-red-600 text-sm font-bold">{error?.extraBedCharge}</p>}
  //       </div>

        
  //     </div>

  //   </div>

  //   <div className="hidden md:flex mt-6 flex-row gap-x-2 items-center justify-center mb-[30px]">
  //       <Button
  //         variant={EVARIANTS.PILL}
  //         color={ECOLOR.THREE}
  //         className="!rounded-[12px] !px-[60px]"
  //         onClick={handleCancel}
  //       >
  //         <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#787878]">
  //           Cancel
  //         </p>
  //       </Button>
  //       <Button
  //         variant={EVARIANTS.PILL}
  //         color={ECOLOR.TWO}
  //         className="!rounded-[12px] "
  //         onClick={updateRoomPrice}
  //       >
  //         <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#FFFFFF]">
  //           Save Changes
  //         </p>
  //       </Button>
  //     </div>
  //     <ToastContainer position="top-center" />

  // </>
  <>
  <div className="flex h-full flex-col md:hidden gap-y-3 mb-[50px] md:mb-0 overflow-y-auto px-3 mt-2 ">
        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Number of Adults
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Number of adults"
            name="adults"
            value={roomData?.adults}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.adults && (
            <p className="text-red-600 text-sm font-bold">{error?.adults}</p>
          )}
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Price
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Price"
            name="price"
            value={roomData?.price}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.price && (
            <p className="text-red-600 text-sm font-bold">{error?.price}</p>
          )}
        </div>

 

       
        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Extra Bed Charge
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Extra Bed Charge"
            name="extraBedCharge"
            value={roomData?.extraBedCharge}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.extraBedCharge && (
            <p className="text-red-600 text-sm font-bold">
              {error?.extraBedCharge}
            </p>
          )}
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Maximum Adult Capacity
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Maximum capacity"
            name="maxAdults"
            value={roomData?.maxAdults}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.maxAdults && (
            <p className="text-red-600 text-sm font-bold">{error?.maxAdults}</p>
          )}
        </div>

        {room?.roomType && <p className="font-['Montserrat'] font-semibold mt-5 text-[16px] leading-[22px] tracking-[0.2px] text-[#000000] ">
              Meals Price (per person)
            </p>}
           {room?.roomType && <div className="flex flex-row mt-[-10px] gap-x-2">
            <p className="text-red-500">Click checkbox to update meal</p>
              <input
              type="checkbox"
              checked={isUpdateMeal}
              onChange={handleCheckboxChange}
              className="h-[20px] w-[20px]"
              name="updateMeal"
            />                      

           </div>  }

       {room?.roomType &&  <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Breakfast Rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Breakfast rate"
            name="breakfast"
            value={roomData?.breakfast}
            onChange={onInputChange}
            disabled={!isUpdateMeal }
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.breakfast && (
            <p className="text-red-600 text-sm font-bold">{error?.breakfast}</p>
          )}
        </div>}

       {room?.roomType && <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Lunch rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Lunch rate"
            name="lunch"
            value={roomData?.lunch}
            onChange={onInputChange}
            disabled={!isUpdateMeal }
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.lunch && (
            <p className="text-red-600 text-sm font-bold">{error?.lunch}</p>
          )}
        </div>}

      {room?.roomType &&  <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Dinner Rate (optional){" "}
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Dinner rate"
            name="dinner"
            value={roomData?.dinner}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.dinner && (
            <p className="text-red-600 text-sm font-bold">{error?.dinner}</p>
          )}
        </div>}

       {room?.roomType && <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Combined Meal Rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Combined meal rate"
            name="allMeals"
            value={roomData?.allMeals}
            disabled={!isUpdateMeal }
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.allMeals && (
            <p className="text-red-600 text-sm font-bold">{error?.allMeals}</p>
          )}
        </div>}

        {childData?.length > 0 && (
          <div className="flex flex-col md:hidden mt-2">
            <p className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45] mb-1">
              Child Price
            </p>

            {childData.map((child, index) => (
              <div key={index}>
                <div className="flex  gap-2 items-end mb-2">
                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Min Age:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.minAge}
                      onChange={(e) =>
                        handleChange(index, "minAge", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[80px]"
                      placeholder="Min age"
                    />
                  </div>

                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Max Age:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.maxAge}
                      onChange={(e) =>
                        handleChange(index, "maxAge", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[80px]"
                      placeholder="Max age"
                    />
                  </div>

                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Price:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.price}
                      onChange={(e) =>
                        handleChange(index, "price", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[80px]"
                      placeholder="price"
                    />
                  </div>

                  <button
                    onClick={() => deleteField(index)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    -
                  </button>

                  <button
                    onClick={addNewField}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                  >
                    +
                  </button>
                </div>
              
              </div>
            ))}
          </div>
        )}

             {/* <p className="font-['Montserrat'] font-semibold text-[16px] leading-[22px] tracking-[0.2px] text-[#000000] ">
              Meals Price (per person)
            </p>
           <div className="flex flex-row mt-[-10px] gap-x-2">
            <p className="text-red-500">Click checkbox to update meal</p>
              <input
              type="checkbox"
              checked={isUpdateMeal}
              onChange={handleCheckboxChange}
              className="h-[20px] w-[20px]"
              name="updateMeal"
            />                      

           </div>  

         <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Breakfast Rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Breakfast rate"
            name="breakfast"
            value={roomData?.breakfast}
            onChange={onInputChange}
            disabled={!isUpdateMeal }
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.breakfast && (
            <p className="text-red-600 text-sm font-bold">{error?.breakfast}</p>
          )}
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Lunch rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Lunch rate"
            name="lunch"
            value={roomData?.lunch}
            onChange={onInputChange}
            disabled={!isUpdateMeal }
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.lunch && (
            <p className="text-red-600 text-sm font-bold">{error?.lunch}</p>
          )}
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Dinner Rate (optional){" "}
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Dinner rate"
            name="dinner"
            value={roomData?.dinner}
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.dinner && (
            <p className="text-red-600 text-sm font-bold">{error?.dinner}</p>
          )}
        </div>

        <div className="flex flex-col gap-y-2">
          <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
            Combined Meal Rate (optional)
          </label>
          <Input
            type={INPUT_TYPES.TEXT}
            placeholder="Combined meal rate"
            name="allMeals"
            value={roomData?.allMeals}
            disabled={!isUpdateMeal }
            onChange={onInputChange}
            className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
          />
          {error?.allMeals && (
            <p className="text-red-600 text-sm font-bold">{error?.allMeals}</p>
          )}
        </div> */}

         <div className="flex md:hidden flex-row justify-center gap-x-2">
            <p className="text-blue-700 font-bold">Update Default Price Only</p>
              <input
              type="checkbox"
              checked={updateDefaultPrice}
              onChange={()=>toggleUpdateDefaultPrice(!updateDefaultPrice)}
              className="h-[20px] w-[20px]"
              name="updateDefaultPrice"
            />                      

           </div> 


        <div className="flex mt-3 flex-row gap-x-2 justify-between">
          <Button
            variant={EVARIANTS.PILL}
            color={ECOLOR.THREE}
            className="!rounded-[12px] flex-1 !px-[10px] "
            onClick={handleCancel}
          >
            <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#787878]">
              Cancel
            </p>
          </Button>
          <Button
            variant={EVARIANTS.PILL}
            color={ECOLOR.TWO}
            className="!rounded-[12px] flex-1"
            onClick={updateRoomPrice}
          >
            <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#FFFFFF]">
              Save Changes
            </p>
          </Button>
        </div>
      </div>

      <div className="flex flex-col py-[20px]">
        <div className="hidden h-full md:flex justify-start gap-x-[100px] items-start px-[100px] ">
          <div className="flex flex-col gap-y-3">
            <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Number of Adults
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Number of adults"
                name="adults"
                value={roomData?.adults}
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.adults && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.adults}
                </p>
              )}
            </div>

             <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Maximum Capacity
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Maximum capacity"
                name="maxAdults"
                value={roomData?.maxAdults}
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.maxAdults && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.maxAdults}
                </p>
              )}
            </div>
           
             {room?.roomType && <p className="font-['Montserrat'] font-semibold text-[16px] leading-[22px] tracking-[0.2px] text-[#000000] ">
              Meals Price (per person)
            </p>}
         {room?.roomType &&  <div className="flex flex-row gap-x-2">
            <p className="text-red-500">Click checkbox to update meal</p>
              <input
              type="checkbox"
              checked={isUpdateMeal}
              onChange={handleCheckboxChange}
              className="h-[20px] w-[20px]"
              name="updateMeal"
            />                      

           </div>    }     
            
           {room?.roomType && <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Breakfast Rate (optional)
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Breakfast rate"
                name="breakfast"
                value={roomData?.breakfast}
                onChange={onInputChange}
                disabled={!isUpdateMeal }
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.breakfast && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.breakfast}
                </p>
              )}
            </div>}

           {room?.roomType && <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Lunch rate (optional)
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Lunch rate"
                name="lunch"
                value={roomData?.lunch}
                disabled={!isUpdateMeal }
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.lunch && (
                <p className="text-red-600 text-sm font-bold">{error?.lunch}</p>
              )}
            </div>}

           
          </div>

          <div className="flex flex-col gap-y-3">
            <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Price
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Price"
                name="price"
                value={roomData?.price}
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.price && (
                <p className="text-red-600 text-sm font-bold">{error?.price}</p>
              )}
            </div>
             <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Extra Bed Charge
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Extra Bed Charge"
                name="extraBedCharge"
                value={roomData?.extraBedCharge}
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.extraBedCharge && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.extraBedCharge}
                </p>
              )}
            </div>

           {room?.roomType && <div className="flex flex-col mt-[48px] gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Dinner Rate (optional){" "}
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Dinner rate"
                name="dinner"
                value={roomData?.dinner}
                onChange={onInputChange}
                disabled={!isUpdateMeal }
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.dinner && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.dinner}
                </p>
              )}
            </div>}

           {room?.roomType && <div className="flex flex-col gap-y-2">
              <label className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45]">
                Combined Meal Rate (optional)
              </label>
              <Input
                type={INPUT_TYPES.TEXT}
                placeholder="Combined meal rate"
                name="allMeals"
                value={roomData?.allMeals}
                disabled={!isUpdateMeal }
                onChange={onInputChange}
                className="h-[35px] px-3 w-full border border-[#C4C4C4] !rounded-[10px] bg-[#F2F2F2] placeholder:font-['Montserrat'] placeholder:font-normal placeholder:text-[16px] placeholder:leading-[22px] placeholder:tracking-[0.2px] placeholder:text-[#000000]"
              />
              {error?.allMeals && (
                <p className="text-red-600 text-sm font-bold">
                  {error?.allMeals}
                </p>
              )}
            </div>}

           
          </div>
        </div>

        {childData.length > 0  && (
          <div className="hidden md:block mt-4 px-[100px]">
            <p className="font-['Montserrat'] font-medium text-[20px] leading-[16px] text-[#222B45] mb-1">
              Child Price
            </p>

            {childData.map((child, index) => (
              <div key={index}>
                <div className="flex gap-2 items-end mb-2">
                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Min Age:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.minAge}
                      onChange={(e) =>
                        handleChange(index, "minAge", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[100px]"
                      placeholder="Min age"
                    />
                  </div>

                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Max Age:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.maxAge}
                      onChange={(e) =>
                        handleChange(index, "maxAge", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[100px]"
                      placeholder="Max age"
                    />
                  </div>

                  <div>
                    {index === 0 && (
                      <label className="block text-sm font-medium mb-1">
                        Price:
                      </label>
                    )}

                    <input
                      type={INPUT_TYPES.TEXT}
                      value={child.price}
                      onChange={(e) =>
                        handleChange(index, "price", e.target.value)
                      }
                      className="border border-[#C4C4C4] py-1 px-2 rounded w-[100px]"
                      placeholder="price"
                    />
                  </div>

                  <button
                    onClick={() => deleteField(index)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    -
                  </button>

                  <button
                    onClick={addNewField}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                  >
                    +
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

       <div className="hidden md:flex flex-row justify-center gap-x-2">
            <p className="text-blue-700 font-bold">Update Default Price Only</p>
              <input
              type="checkbox"
              checked={updateDefaultPrice}
              onChange={()=>toggleUpdateDefaultPrice(!updateDefaultPrice)}
              className="h-[20px] w-[20px]"
              name="updateDefaultPrice"
            />                      

           </div>  

      <div className="hidden md:flex mt-6 flex-row gap-x-2 items-center justify-center mb-[30px]">
        <Button
          variant={EVARIANTS.PILL}
          color={ECOLOR.THREE}
          className="!rounded-[12px] !px-[60px]"
          onClick={handleCancel}
        >
          <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#787878]">
            Cancel
          </p>
        </Button>
        <Button
          variant={EVARIANTS.PILL}
          color={ECOLOR.TWO}
          className="!rounded-[12px] "
          onClick={updateRoomPrice}
        >
          <p className="font-['Montserrat'] font-semibold text-[16px] leading-[19px] text-[#FFFFFF]">
            Save Changes
          </p>
        </Button>
      </div>
      <ToastContainer position="top-center" />
    </>
  );
};

export default ManageRate;
